import { FiltersMap } from '../model';
import { WixPatternsMonitor } from '../services';
import { CollectionState } from './CollectionState';

export interface FedopsReporterParams<T, F extends FiltersMap> {
  componentName: string;
  collection: CollectionState<T, F>;
  internalMonitor: WixPatternsMonitor;
}

export class FedopsReporter<T, F extends FiltersMap> {
  componentName;
  collection;
  internalMonitor;

  constructor(params: FedopsReporterParams<T, F>) {
    this.componentName = params.componentName;
    this.collection = params.collection;
    this.internalMonitor = params.internalMonitor;

    const { internalMonitor, componentName, collection } = this;

    internalMonitor.reportInteractionStart(componentName, 'initial-load');
    internalMonitor.reportInteractionStart(componentName, 'e2e');

    collection.hooks.once('beforeInitialFetch', ({ isStale }) => {
      const customProps = { cached: !isStale };

      internalMonitor.reportInteractionEnd(componentName, 'initial-load');
      internalMonitor.reportInteractionStart(
        componentName,
        'initial-fetch-data',
        customProps,
      );

      collection.emitter.once('ready', () => {
        internalMonitor.reportInteractionEnd(
          componentName,
          'initial-fetch-data',
          customProps,
        );
      });
    });
  }

  onFullRenderStart() {
    const { internalMonitor, componentName } = this;

    internalMonitor.reportInteractionStart(
      componentName,
      'initial-full-render',
    );

    return () => {
      internalMonitor.reportInteractionEnd(
        componentName,
        'initial-full-render',
      );
      internalMonitor.reportInteractionEnd(componentName, 'e2e');
    };
  }
}
